<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M19.4486 18.8975H0.67128L10.06 1.2793L19.4486 18.8975Z" fill="currentColor" stroke="currentColor" stroke-width="1.20464" />
    </svg>
</template>
